import { ClaimsSearch } from "./ClaimsSearch";
import { Box, Flex, Text } from "@chakra-ui/react";
import { t } from "i18next";
import { Button } from "@digital-services-gard-as/anchor-react";

type ClaimSectionProps = {
    isEditing: boolean;
    draft: { claimRef: string | null };
    updateClaim: (claimRef: string, clientName: string, vesselName: string) => Promise<void>;
    claimRef?: string;
    startEditing: () => void;
};

export const ClaimSection = ({ isEditing, draft, updateClaim, claimRef, startEditing }: ClaimSectionProps) => {
    if (isEditing) {
        return <ClaimsSearch tempClaimRef={draft.claimRef} onClaimChange={updateClaim} />;
    }
    return (
        <Box>
            <Text mb="0.5rem" display="block" asChild>
                <b>{t("invoices:createInvoice.generalInfo.gardClaimRef")}</b>
            </Text>
            <Flex gap="0.5rem" align="center">
                <Text id="gardClaimRef">{claimRef ?? "—"}</Text>
                <Button type="button" variant="tertiary" onClick={startEditing} data-testid="editClaimButton">
                    {t("invoices:createInvoice.generalInfo.edit")}
                </Button>
            </Flex>
        </Box>
    );
};
